import { getVideoCapabilities } from '@mi-front/core';
import debugFn from 'debug';
import Player from 'video.js/dist/types/player';
import { setupHlsJs } from './setup-hls-js';

const debug = debugFn('video-js-setup');

const VIDEO_CAPABILITIES = getVideoCapabilities();

export function setupVideoJsPlayerTech(
  player: Player,
  src: string,
  {
    isLive,
  }: {
    isLive?: boolean;
  },
) {
  // MP4 sources can be played directly without HLS processing
  if (src.includes('.mp4')) {
    debug('MP4 source detected → direct playback');
    player.src({ src, type: 'video/mp4' });
    return;
  }

  debug('Setting up HLS tech');

  if (VIDEO_CAPABILITIES.hlsSupport === 'hlsjs') {
    setupHlsJs(player, src, isLive ? 'live' : 'vod');
  } else if (VIDEO_CAPABILITIES.hlsSupport === 'native') {
    debug('Native HLS → just set src and let the OS handle it');
    player.src({
      src,
      type: 'application/vnd.apple.mpegURL',
    });

    // Case B: MSE available → use hls.js (bypass VHS entirely)
  } else {
    debug('No MSE, no native HLS → previous setup using video.js VHS');
    player.src({ src, type: 'application/x-mpegURL' });
  }
}
